import { Link } from '@tanstack/react-router';
import { Button } from '@mailserver/web-shared/ui';
import { useT } from '@mailserver/web-shared';

export function NotFoundPage() {
  const t = useT();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-3xl font-semibold">{t('notFound.title')}</h1>
      <p className="text-muted-foreground">{t('notFound.body')}</p>
      <Button asChild>
        <Link to="/">{t('notFound.action')}</Link>
      </Button>
    </div>
  );
}
